import { Provider } from 'react-redux';
import { LayoutBuilder } from '~/rage/utils';
import { Layouts } from '~/shared';
import { store } from './redux';
import { AnimationWrapper } from './views/animate';
import { Tablet } from './views/Tablet';
import { Background } from './components/Background';

const LayoutComponent = () => (
	<Provider store={store}>
		<AnimationWrapper>
			<Background />
			<Tablet />
		</AnimationWrapper>
	</Provider>
);

const Layout = new LayoutBuilder(LayoutComponent)
	.setDisplayName(Layouts.Tablet)
	.setHudVisible(true)
	.setTransitionTime(400)
	.build();

export default Layout;
